import { memo, useCallback } from 'react'
import { Box, Text, Group, Badge } from 'components'
import { IconChevronRight } from '@tabler/icons-react'
import { TreeItem } from './types'

interface BrowseTreeNavigationItemProps {
  item: TreeItem
  count: number
  onClick: (item: TreeItem) => void
}

export const BrowseTreeNavigationItem = memo(({
  item,
  count,
  onClick,
}: BrowseTreeNavigationItemProps) => {
  const handleClick = useCallback(() => {
    onClick(item)
  }, [onClick, item])

  return (
    <Box
      onClick={handleClick}
      sx={theme => ({
        padding: '16px 20px',
        borderRadius: theme.radius.md,
        border: `1px solid ${
          theme.colorScheme === 'dark'
            ? theme.colors.dark[4]
            : theme.colors.gray[3]
        }`,
        backgroundColor: theme.colorScheme === 'dark'
          ? theme.colors.dark[6]
          : theme.white,
        boxShadow: theme.shadows.sm,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: theme.shadows.md,
          backgroundColor: theme.colorScheme === 'dark'
            ? theme.colors.dark[5]
            : theme.colors.gray[0],
          borderColor: theme.colorScheme === 'dark'
            ? theme.colors.dark[3]
            : theme.colors.gray[4],
        },
      })}
    >
      <Text
        size="sm"
        sx={{
          flex: 1,
          minWidth: 0,
          lineHeight: 1.5,
          fontWeight: 400,
        }}
      >
        {item.name}
      </Text>
      <Group spacing={10} sx={{ flexShrink: 0 }}>
        {count > 0 && (
          <Badge
            size="md"
            color="teal"
            variant="light"
            radius="xl"
            sx={{
              fontWeight: 500,
              fontSize: 12,
              padding: '0 10px',
              height: 24,
              minWidth: 24,
            }}
          >
            {count}
          </Badge>
        )}
        <IconChevronRight size={18} stroke={1.5} style={{ color: '#868e96' }} />
      </Group>
    </Box>
  )
})

BrowseTreeNavigationItem.displayName = 'BrowseTreeNavigationItem'
